module.exports = __webpack_public_path__ + "img/about_icon.a16404f4.svg";